<template>
  <Confirmation />
</template>

<script>
import Confirmation from '@/components/login/Confirmation.vue'

export default {
  name: 'ConfirmationPage',
  components: { Confirmation }
}
</script>

<style scoped>

</style>
